import React, { useState } from 'react';
import { useLang } from '../LanguageContext';
import './QnA.css';

const T = {
  heading: { ko: '자주 묻는 질문', en: 'Frequently Asked Questions' },
  desc:    { ko: '궁금한 점이 있으시면 아래를 확인해주세요', en: 'If you have any questions, please check below.' },
  faqs: [
    {
      q: { ko: '스마트 기저귀 센서의 배터리 수명은 얼마나 되나요?',
           en: 'How long does the smart diaper sensor battery last?' },
      a: { ko: '스마트 기저귀 센서는 LoRa 장거리 무선 통신을 사용하며, 일반적인 사용 환경에서 약 2주 정도 사용 가능합니다. 배터리 잔량은 대시보드 화면에서 확인할 수 있습니다.',
           en: 'The sensor uses LoRa long-range wireless and typically lasts about two weeks under normal use. Battery levels can be checked on the dashboard.' },
    },
    {
      q: { ko: '기존 요양시설에 스마트 기저귀 시스템 설치가 가능한가요?',
           en: 'Can the system be installed in existing care facilities?' },
      a: { ko: '네, 별도의 공사 없이 기존 요양원·요양병원에 바로 설치할 수 있습니다. Wi-Fi 또는 유선 LAN 환경만 갖춰져 있으면 중계기 설치 후 바로 스마트 기저귀 서비스를 이용하실 수 있습니다. 센서, 중계기, 대시보드를 하나의 패키지로 제공하며, 택배 발송 후 설명서를 동봉하여 직접 설치하실 수 있습니다. 직접 방문 설치를 원하시는 경우 별도 출장비가 발생할 수 있습니다.',
           en: 'Yes — no construction needed. With existing Wi-Fi or wired LAN, just install the repeater and you’re ready. We deliver the sensor, repeater, and dashboard as a package with installation instructions. On-site installation by our team is available for an additional fee.' },
    },
    {
      q: { ko: '스마트 기저귀로 수집된 헬스케어 데이터 보안은 어떻게 관리되나요?',
           en: 'How is the collected healthcare data secured?' },
      a: { ko: '모든 헬스케어 데이터는 암호화되어 전송되며, 국내 클라우드 서버에 안전하게 저장됩니다. 개인정보보호법을 준수하며, 접근 권한은 요양시설 관리자가 직접 설정할 수 있습니다.',
           en: 'All healthcare data is encrypted in transit and stored securely on domestic cloud servers. We comply with Korean Personal Information Protection laws, and access permissions are managed directly by facility administrators.' },
    },
    {
      q: { ko: '스마트 기저귀 서비스 도입 비용은 어떻게 되나요?',
           en: 'What does the service cost?' },
      a: { ko: '요양시설 규모와 입소자 수에 따라 맞춤 견적을 드립니다. 센서, 중계기, 대시보드가 하나의 통합 패키지로 제공되며, 월 구독 형태와 일시불 구매 모두 가능합니다. 자세한 내용은 문의하기를 통해 상담받으실 수 있습니다.',
           en: 'Custom quotes are provided based on facility size and resident count. The integrated package (sensor, repeater, dashboard) is available as either a monthly subscription or one-time purchase. Please contact us for details.' },
    },
    {
      q: { ko: '스마트 기저귀 센서가 피부에 안전한가요?',
           en: 'Is the sensor safe for skin?' },
      a: { ko: '센서는 피부에 직접 접촉하지 않고 기저귀 외부에 부착됩니다. 의료기기 인증을 받은 소재를 사용하며, 피부 자극 테스트를 완료한 안전한 제품입니다. 어르신의 피부 건강을 최우선으로 설계했습니다.',
           en: 'The sensor attaches to the outside of the diaper — it does not touch skin directly. It uses medically certified materials and has passed skin irritation testing. Resident skin health is our top priority.' },
    },
    {
      q: { ko: '일반 가정에서도 스마트 기저귀를 사용할 수 있나요?',
           en: 'Can it be used at home?' },
      a: { ko: '네, 재가돌봄(가정 간병) 환경에서도 사용 가능합니다. 가정용 Wi-Fi만 있으면 스마트 기저귀 센서와 모바일 앱을 통해 보호자가 실시간으로 어르신의 상태를 확인하고 기저귀 교체 알림을 받을 수 있습니다.',
           en: 'Yes — it works for home care environments too. With just home Wi-Fi, family members can check resident status and receive diaper-change alerts via the mobile app in real time.' },
    },
  ],
};

function QnA() {
  const [activeIndex, setActiveIndex] = useState(null);
  const { lang } = useLang();

  const toggle = (i) => {
    setActiveIndex(activeIndex === i ? null : i);
  };

  return (
    <section className="section qna">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Q&amp;A</span>
          <h2>{T.heading[lang]}</h2>
          <p className="section-desc">{T.desc[lang]}</p>
        </div>
        <div className="faq-list">
          {T.faqs.map((faq, i) => (
            <div className={`faq-item ${activeIndex === i ? 'active' : ''}`} key={i}>
              <button className="faq-question" onClick={() => toggle(i)}>
                <span>{faq.q[lang]}</span>
                <svg className="faq-arrow" viewBox="0 0 24 24" fill="none">
                  <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </button>
              <div className="faq-answer">
                <p>{faq.a[lang]}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default QnA;
